import { DatePickerProps } from "antd/lib/date-picker/interface"
import { DrawerProps } from "antd/lib/drawer"
import { FormItemProps, FormProps } from "antd/lib/form"
import { InputProps, TextAreaProps } from "antd/lib/input"
import { InputNumberProps } from "antd/lib/input-number"
import { PopoverProps } from "antd/lib/popover"
import { SelectProps } from "antd/lib/select"
import { TooltipProps } from "antd/lib/tooltip"

type TDefaultProps = {
  input?: InputProps
  inputNumber?: InputNumberProps
  textarea?: TextAreaProps
  datePicker?: DatePickerProps
  select?: SelectProps
  drawer?: DrawerProps
  form?: FormProps & { confirmOnUnload: boolean }
  formItem?: FormItemProps
  tooltipProps?: TooltipProps
  popoverProps?: PopoverProps
}

export const defaultProps: TDefaultProps = {
  input: {
    placeholder: 'Enter',
    allowClear: true,
  },
  inputNumber: {
    placeholder: 'Enter',
    max: 1000000000,
    formatter: (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ','),
    precision: 0
  },
  drawer: {
    destroyOnClose: true,
    closable: false,
    keyboard: false,
    maskClosable: false,
  },
  form: {
    confirmOnUnload: true
  },
  formItem: {
    colon: false,
    help: '',
    style: { marginBottom: 0 }
  },
  tooltipProps: {
    title: null
  },
  popoverProps: {

  }
}
